import Vue from 'vue'

import VueMeta from 'vue-meta'
import VModal from 'vue-js-modal'
import VuejsDialog from 'vuejs-dialog'
import VueTextareaAutosize from 'vue-textarea-autosize'
import { VClosePopover, VTooltip, VPopover } from 'v-tooltip'

import App from '@/App.vue'
import i18n, { setCurrentLocale } from '@/i18n'
import router from '@/router'
import store from '@/store'
import ConfirmDialog from '@/components/ConfirmDialog/ConfirmDialog.vue'
import { SETTINGS__INIT } from './store/actions'
import VCalendar from 'v-calendar'

import type { DialogOptions } from 'vuejs-dialog/types'

import '@/assets/scss/main.scss'

const CONFIRM_DIALOG_NAME = 'FOXGID_CONFIRM_DIALOG_NAME'

Vue.config.productionTip = false

Vue.use(VueMeta, {})
Vue.use(VModal)
Vue.use(VuejsDialog, {
  view: CONFIRM_DIALOG_NAME,
})
Vue.use(VueTextareaAutosize)
Vue.use(VCalendar)

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('vPopover', VPopover)

Vue.dialog.registerComponent(CONFIRM_DIALOG_NAME, ConfirmDialog)

Vue.use({
  install() {
    const useConfirmDialogFunc = (
      data: string | [string, Partial<DialogOptions>],
      callback = () => null,
      condition = true,
    ) => {
      if (condition) {
        const [text, options] = Array.isArray(data) ? data : [data, { okText: '', cancelText: '' }]
        Vue.dialog
          .confirm(text, options)
          .then(callback)
          .catch(() => null)
      }
    }
    Vue.useConfirmDialog = useConfirmDialogFunc
    Vue.prototype.$useConfirmDialog = useConfirmDialogFunc
  },
})

async function initApp() {
  setCurrentLocale()

  // Initial settings loading
  if (store.getters.isLoggedIn) {
    await store.dispatch(SETTINGS__INIT)
  }

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
    metaInfo: {
      title: 'App',
      titleTemplate: '%s - Foxgid',
    },
  }).$mount('#app')
}

initApp()
